import { initContract } from "@ts-rest/core";
import {
	CreatedUserAttendanceDto,
	findUserAttendanceFilter,
	GroupedUserDayAttendanceDto,
	upsertTimelog,
} from "../validators/attendances.validator";
import {
	findUserQuery,
	PaginatedCreatedUsersDto,
} from "../validators/users.validator";
import {
	CreatedUserStatusDto,
	updateUserStatusInput,
} from "../validators/user-status.validator";

const c = initContract();

export const usersContract = c.router({
	getUsers: {
		method: "GET",
		path: "/users",
		query: findUserQuery,
		responses: {
			200: c.type<PaginatedCreatedUsersDto>(),
		},
		summary: "Get a paginated list of users",
	},
	getUserGroupedAttendances: {
		method: "GET",
		path: "/users/:userId/attendances",
		responses: {
			200: c.type<GroupedUserDayAttendanceDto>(),
		},
		query: findUserAttendanceFilter,
	},
	getLatestUserAttendances: {
		method: "GET",
		path: "/users/:userId/attendances/latest",
		responses: {
			200: c.type<CreatedUserAttendanceDto>(),
		},
	},
	upsertUserAttendance: {
		method: "PUT",
		path: "/users/:userId/attendances",
		body: upsertTimelog,
		responses: {
			200: c.type<CreatedUserAttendanceDto>(),
			201: c.type<CreatedUserAttendanceDto>(),
		},
	},
	updateUserStatus: {
		method: "PUT",
		path: "/users/:userId/status",
		body: updateUserStatusInput,
		responses: {
			200: c.type<CreatedUserStatusDto>(),
		},
	},
	getUserStatus: {
		method: "GET",
		path: "/users/:userId/status",
		responses: {
			200: c.type<CreatedUserStatusDto>(),
		},
	},
});
